export default __webpack_public_path__ + "static/media/organization_name_grey.dede67f0.png";